import React from "react";
import ProductBox from "../ProductBox";
import ProductLoader from "./ProductLoader";

const ProductDisplay = ({ data, productName }) => {
	const [rangeValue, setRangeValue] = React.useState(0);

	const handleRangeChange = (e) => {
		setRangeValue(e.target.value);
	};

	const filteredData = data
		? data.filter(
				(product) =>
					(rangeValue === 0 ||
						rangeValue === "0" ||
						parseFloat(product.prices[0].unit_amount) <= parseFloat(rangeValue)) &&
					(productName === "" ||
						product.name.toLowerCase().includes(productName.toLowerCase())),
			)
		: [];

	return (
		<div className="mb-20 w-full font-jost">
			<div className="w-full">
				<div className="flex flex-col md:flex-row justify-between items-end mb-8 md:mb-12 border-b border-gray-100 pb-6">
					<div>
						<h3 className="capitalize font-bold text-3xl md:text-4xl text-gray-900 tracking-tight">
							Nails For You
						</h3>
						<p className="text-gray-500 mt-2 text-sm md:text-base max-w-lg">
							Explore our meticulously handcrafted collection of luxury press-on nails.
						</p>
					</div>
					
					<div className="w-full md:w-auto mt-6 md:mt-0 flex items-center bg-gray-50 rounded-2xl px-4 py-2 border border-gray-100">
						<label htmlFor="sort" className="mr-3 text-sm font-medium text-gray-700 whitespace-nowrap">
							Max Price:
						</label>
						<input
							type="range"
							id="sort"
							name="sort"
							min="0"
							max="100"
							step="5"
							className="slider accent-[#FFB7CF] bg-gray-200 h-1.5 rounded-lg appearance-none cursor-pointer w-24 md:w-32"
							value={rangeValue}
							onChange={handleRangeChange}
						/>
						<span className="ml-3 font-semibold text-gray-900 min-w-[3rem] text-right">
							{rangeValue === 0 || rangeValue === "0" ? "Any" : `$${rangeValue}`}
						</span>
					</div>
				</div>

				<div className="w-full">
					<div
						className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 items-stretch w-full mx-auto max-w-full
                     gap-4 md:gap-6 lg:gap-8 justify-start"
					>
						{data === null ? (
							[...Array(8)].map((_, index) => <ProductLoader key={index} />)
						) : filteredData.length === 0 ? (
							<div className="w-full text-center col-span-full py-20 bg-gray-50 rounded-3xl border border-gray-100 border-dashed">
								<h4 className="text-xl font-semibold text-gray-900 mb-2">No matching sets found</h4>
								<p className="text-gray-500">Try adjusting your price filter or search query.</p>
							</div>
						) : (
							filteredData.map((e) => (
								<div className="w-full h-full" key={e?.id}>
									<ProductBox
										name={e.name}
										id={e?.id}
										price={e?.prices[0].unit_amount}
										alt={e.name}
										image={e?.images[0]}
										item={e}
									/>
								</div>
							))
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductDisplay;
